import React from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useAnonymous } from '../contexts/AnonymousContext';
import { useAuth } from '../contexts/AuthContext';
import { colors, typography, spacing } from '../../styles/theme';

export function UsageBanner() {
  const { isAuthenticated } = useAuth();
  const { tier, usageInfo, tierRules } = useSubscription();
  const { roundsToday: anonRounds, dailyLimit: anonLimit, remainingRounds: anonRemaining } = useAnonymous();

  // Don't show for paid users (unlimited)
  if (tier === 'paid') {
    return null;
  }

  // Anonymous users - Clean and simple with better contrast
  if (!isAuthenticated) {
    const isDanger = anonRounds >= anonLimit;

    return (
      <div style={{
        padding: `${spacing[3]} ${spacing[6]}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: spacing[4],
        fontSize: typography.sm,
        fontFamily: typography.fontSans,
        background: 'rgba(15, 23, 42, 0.8)',
        borderLeft: `3px solid ${isDanger ? colors.error : colors.primary}`,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ 
          color: colors.textSecondary,
          fontWeight: typography.normal
        }}>
          Trial rounds today:{' '}
          <span style={{ 
            color: colors.textPrimary,
            fontWeight: typography.semibold
          }}>
            {anonRounds} of {anonLimit}
          </span>
        </div>
        {isDanger && (
          <a
            href="/signup"
            style={{
              fontSize: typography.xs,
              fontWeight: typography.semibold,
              color: colors.primary,
              textDecoration: 'none',
              transition: 'opacity 0.15s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            Sign up →
          </a>
        )}
      </div>
    );
  }

  // Free users - Clean and simple with better contrast
  if (tier === 'free') {
    const roundsToday = usageInfo?.roundsToday || 0;
    const dailyLimit = tierRules.dailyRounds;
    const remaining = usageInfo?.remainingToday ?? (dailyLimit - roundsToday);
    
    const isDanger = remaining === 0;
    
    const accentColor = isDanger ? colors.error : colors.primary;

    return (
      <div style={{
        padding: `${spacing[3]} ${spacing[6]}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: spacing[4],
        fontSize: typography.sm,
        fontFamily: typography.fontSans,
        background: 'rgba(15, 23, 42, 0.8)',
        borderLeft: `3px solid ${accentColor}`,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ 
          color: colors.textSecondary,
          fontWeight: typography.normal
        }}>
          Rounds today:{' '}
          <span style={{ 
            color: colors.textPrimary,
            fontWeight: typography.semibold
          }}>
            {roundsToday} of {dailyLimit}
          </span>
        </div>
        {isDanger && (
          <a
            href="/subscription"
            style={{
              fontSize: typography.xs,
              fontWeight: typography.semibold,
              color: colors.warning,
              textDecoration: 'none',
              transition: 'opacity 0.15s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            Upgrade →
          </a>
        )}
      </div>
    );
  }

  return null;
}

export default UsageBanner;

